<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="violence-adventure-romance-action">
<h1 style="padding-top:180px;">Violence-Adventure <br/>Romance-Action</h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?9667e772